export const SKRILL_SESSION_ID_STORAGE_KEY = 'skrillSessionId';
